// https://sponda-kohteet.stage.crasman.fi/admin/manage/scriptlets/scriptletmanager/scriptleteditor/html/code/show/nbcsv3O1TXuKvD70vEWycQ

import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import { colorClassNames } from 'lib/settings';

const pictograms = {
	bus: require(`!raw-loader!../../../../assets/pictograms/${'icon-bussi'}.svg`),
	train: require(`!raw-loader!../../../../assets/pictograms/${'icon-juna'}.svg`),
	metro: require(`!raw-loader!../../../../assets/pictograms/${'icon-metro'}.svg`),
	bike: require(`!raw-loader!../../../../assets/pictograms/${'icon-pyora'}.svg`),
	airport: require(`!raw-loader!../../../../assets/pictograms/${'icon-lentokone'}.svg`),
};

const mapMarker = require(`!raw-loader!../../../../assets/${'marker'}.svg`);

const Accessibility = props => {
	const {
		t,
		options,
		language,
		building: {
			address,
			zip_code,
			city,
			i18n,
			map_zoom,
			latitude,
			longitude,
			spaces,
			construction_year,
			renevation_year,
			floors,
			total_area,
			energy_efficiency_program,
			energy_class,
			environment_certificate,
			building_services,
		},
		buildingFieldLocalNames,
	} = props;

	const backgroundColor = options['background-color'];
	const bgColorClass = backgroundColor in colorClassNames ? colorClassNames[backgroundColor] : '';
	const totalArea = total_area.replace('m2', '').replace('m²', '').trim() + ' m²';

	let componentClass = 'b-component b-accessibility';

	if (bgColorClass) {
		componentClass += ' b-slot-theme-' + bgColorClass;
	}

	const style = {
		backgroundColor,
	};

	let name = '';

	if (i18n[language].neighborhood !== '') {
		name += ` (${i18n[language].neighborhood})`;
	}

	const spaceTypes = spaces.map(space => space.type);
	const uniqueSpaceTypes = spaceTypes.filter((type, index) => spaceTypes.findIndex(type2 => type2 === type) === index)
		.filter(v => v !== '');

	const properties = [
		{
			title: 'building/details/Space types',
			value: uniqueSpaceTypes.map(type => t('space-type/' + type)).join(', '),
		},
		{
			title: 'browse/Building/List/Construction year',
			value: construction_year,
		},
		{
			title: 'a11y/Renovation year',
			value: renevation_year,
		},
		{
			title: 'building/details/Floors',
			value: floors
		},
		{
			title: 'building/details/Area',
			value: totalArea
		},
		{
			title: 'a11y/Energy efficiency class',
			value: energy_class,
		},
		{
			title: 'a11y/Energy efficiency program',
			value: energy_efficiency_program ? t('general/toggle/yes') : t('general/toggle/no')
		},
		{
			title: 'a11y/Environment certificate',
			value: environment_certificate.toUpperCase()
		},
	].filter(prop => prop.value !== '' && prop.value !== '0');

	const services = [
		{
			title: 'meeting_rooms',
			field: 'meeting-rooms',
		},
		{
			title: 'sauna',
			field: 'sauna',
		},
		{
			title: 'reception',
			field: 'reception',
		}
	];

	const mapSrc = [
		'https://maps.googleapis.com/maps/api/staticmap',
		'?language=fi&region=FI&key=AIzaSyDqDR8HPV8BhJXQJj20fx9bYTE2tx3eCZ8&size=640x640&format=png',
		`&scale=2&zoom=${map_zoom}&center=${latitude},${longitude}`,
		'&style=feature:landscape%7Celement:geometry.fill%7Ccolor:0xf0f0f0&style=feature:landscape.man_made%7Celement:geometry%7Cvisibility:off&style=feature:poi%7Celement:labels.icon%7Ccolor:0x3f3f3f&style=feature:poi%7Celement:labels.text.fill%7Ccolor:0x3f3f3f&style=feature:poi%7Celement:labels.text.stroke%7Ccolor:0xffffff&style=feature:poi.attraction%7Celement:geometry.fill%7Cvisibility:off&style=feature:poi.attraction%7Celement:geometry.stroke%7Cvisibility:off&style=feature:poi.business%7Cvisibility:off&style=feature:poi.government%7Cvisibility:off&style=feature:poi.medical%7Cvisibility:off&style=feature:poi.park%7Celement:geometry.fill%7Ccolor:0x99ce4a%7Csaturation:0%7Cgamma:1&style=feature:poi.park%7Celement:labels%7Cvisibility:off&style=feature:poi.place_of_worship%7Celement:geometry%7Cvisibility:off&style=feature:poi.school%7Cvisibility:off&style=feature:poi.sports_complex%7Cvisibility:off&style=feature:road%7Celement:geometry.fill%7Ccolor:0xffffff&style=feature:road%7Celement:geometry.stroke%7Ccolor:0xff0000%7Cvisibility:off&style=feature:road%7Celement:labels.text.fill%7Ccolor:0x3f3f3f&style=feature:road%7Celement:labels.text.stroke%7Ccolor:0xffffff&style=feature:road.arterial%7Celement:geometry.fill%7Ccolor:0xffffff&style=feature:road.arterial%7Celement:geometry.stroke%7Cvisibility:off&style=feature:road.highway%7Celement:geometry.stroke%7Ccolor:0xff0000%7Cvisibility:off&style=feature:road.highway.controlled_access%7Celement:geometry.stroke%7Ccolor:0xff0000%7Cvisibility:off&style=feature:road.local%7Celement:geometry.fill%7Ccolor:0xffffff&style=feature:road.local%7Celement:geometry.stroke%7Cvisibility:off&style=feature:transit.line%7Celement:geometry.fill%7Ccolor:0xbcbcbc&style=feature:transit.line%7Celement:geometry.stroke%7Cvisibility:off&style=feature:transit.station%7Celement:labels.text%7Cvisibility:on&style=feature:transit.station%7Celement:labels.text.fill%7Ccolor:0x3f3f3f&style=feature:transit.station%7Celement:labels.text.stroke%7Ccolor:0xffffff&style=feature:water%7Celement:geometry.fill%7Ccolor:0x7bc3e9',
	].join('');
	const mapStyle = {
		backgroundImage: `url(${mapSrc})`
	};

	return (
		<div className={componentClass} style={style}>
			<div className="b-accessibility-building">
				<h1>{address}, {zip_code}, {city}{name}</h1>

				{ i18n[language].ingress !== '' &&
					<p className="b-a11y-ingress" dangerouslySetInnerHTML={{__html: i18n[language].ingress }} />
				}
				{ i18n[language].description !== '' &&
					<p className="b-a11y-description" dangerouslySetInnerHTML={{__html: i18n[language].description }} />
				}

				<div className="b-accessibility-properties">
					{properties.map(({ title, value }) => (
						<div key={title} className="b-a11y-property">
							<h4 dangerouslySetInnerHTML={{__html: t(title) }}></h4>
							<p>{value}</p>
						</div>
					))}

					{services.map(service => {
						const serviceLocalName = buildingFieldLocalNames[language]['building_service_' + service.title];
						const serviceAvailable = building_services.includes(service.field);

						return (
							<div key={service.title} className="b-a11y-property">
								<h4>{serviceLocalName}</h4>
								<p>{t(serviceAvailable ? 'general/toggle/yes' : 'general/toggle/no')}</p>
							</div>
						)
					})}

				</div>
			</div>
			<div className="b-accessibility-map" style={mapStyle} dangerouslySetInnerHTML={{__html: mapMarker }} />
			<div className="b-accessibility-accessibility">
				{ i18n[language].building_service_parking !== '' &&
					<React.Fragment>
					  <h4>{buildingFieldLocalNames[language].building_service_parking}</h4>
					  <p dangerouslySetInnerHTML={{__html: i18n[language].building_service_parking }} />
					</React.Fragment>
				}
				{ i18n[language].accessibility !== '' &&
					<React.Fragment>
					  <h4>{t('a11y/Accessibility')}</h4>
					  <p dangerouslySetInnerHTML={{__html: i18n[language].accessibility }} />
					</React.Fragment>
				}

				<div className="b-a11y-pictograms">
					{['bus', 'train', 'metro', 'bike', 'airport'].map(key => {
						const localValue = i18n[language]['accessibility_' + key];

						return localValue === '' ? null : (
							<div key={key} className="b-a11y-pictogram">
								<div className="b-a11y-pictogram-icon" dangerouslySetInnerHTML={{__html: pictograms[key] }}></div>
								<p>{localValue}</p>
							</div>
						)
					})}
				</div>
			</div>
		</div>
	);
}

Accessibility.propTypes = {
	t: PropTypes.func,
	language: PropTypes.oneOf(['fi', 'en']),
	options: PropTypes.object,
	slotActive: PropTypes.bool,
	building: PropTypes.object,
	buildingFieldLocalNames: PropTypes.object,
}

export default translate('translations')(Accessibility);
